<template>
  <div class="matrix-detail">
    <!-- Yes, detailed -->
    <div class="detail-segment segment-yes">
      <div class="segment-label">
        <p class="label-text">Yes, detailed</p>
      </div>
      <div class="segment-bar">
        <div class="bar-fill bar-green" :style="{ width: data.yesDetailed + '%' }"></div>
      </div>
      <div class="segment-value">
        <span class="value-main value-green">{{ data.yesDetailed }}</span>
        <span class="value-unit">%</span>
      </div>
    </div>

    <!-- Briefly -->
    <div class="detail-segment segment-briefly">
      <div class="segment-label">
        <p class="label-text">Briefly</p>
      </div>
      <div class="segment-bar">
        <div class="bar-fill bar-yellow" :style="{ width: data.briefly + '%' }"></div>
      </div>
      <div class="segment-value">
        <span class="value-main value-yellow">{{ data.briefly }}</span>
        <span class="value-unit">%</span>
      </div>
    </div>

    <!-- No -->
    <div class="detail-segment segment-no">
      <div class="segment-label">
        <p class="label-text">No</p>
      </div>
      <div class="segment-bar">
        <div class="bar-fill bar-red" :style="{ width: data.no + '%' }"></div>
      </div>
      <div class="segment-value">
        <span class="value-main value-red">{{ data.no }}</span>
        <span class="value-unit">%</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MatrixDetail',
  props: {
    data: {
      type: Object,
      default: () => ({
        yesDetailed: 80,
        briefly: 15,
        no: 5
      })
    }
  }
};
</script>

<style scoped>
.matrix-detail {
  display: flex;
  align-items: normal;
  gap: 0;
  height: 41px;
      padding: 0rem 0.75rem;
  width: 100%;
}

.detail-segment {
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  min-width: 25px;
  position: relative;
}

.segment-yes {
  flex: 1;
  min-width: 25px;
}

.segment-briefly {
  width: 60px;
  flex-shrink: 0;
}

.segment-no {
  width: 25px;
  flex-shrink: 0;
  align-items: flex-end;
}

.segment-label {
  width: 100%;
}

.segment-label p {
  margin: 0;
}

.segment-yes .label-text {
  font-size: 13px;
  line-height: 16px;
  white-space: nowrap;
}

.segment-briefly .label-text {
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  white-space: nowrap;
}

.segment-no .label-text {
  font-size: 12px;
  line-height: 12px;
  text-align: right;
  white-space: nowrap;
}

.segment-bar {
  width: 100%;
  height: 2px;
  position: relative;
}

.bar-fill {
  height: 2px;
  transform: skewX(-18.882deg);
  border: 1px solid;
}

.bar-green {
  background: color-mix(in srgb, var(--default-status-green) 20%, transparent);
  border-color: color-mix(in srgb, var(--default-status-green) 20%, transparent);
}

.bar-yellow {
  background: color-mix(in srgb, var(--default-status-yellow) 20%, transparent);
  border-color: color-mix(in srgb, var(--default-status-yellow) 20%, transparent);
}

.bar-red {
  background: color-mix(in srgb, var(--default-status-red) 20%, transparent);
  border-color: color-mix(in srgb, var(--default-status-red) 20%, transparent);
}

.segment-value {
  display: flex;
  align-items: center;
  gap: 2px;
}

.value-main {
  font-size: 14px;
  line-height: 18px;
}

.value-green {
  color: var(--default-status-green);
}

.value-yellow {
  color: var(--default-status-yellow);
}

.value-red {
  color: var(--default-status-red);
}

.value-unit {
  font-size: 11px;
  line-height: 12px;
}
</style>
